import { useEffect, useState } from 'react';
import { FilterOptions } from '@weave/schema-gen-ts/dist/schemas/messaging/shared/v1/bulk.pb';
import { SchemaBulkMessagingService } from '@frontend/api-bulk-messaging';
import { useDebouncedValue } from '@frontend/design-system';

// TODO: Move this utility function out. Add tests and make it awesome!
const removeEmptyValues = (obj: Record<string, any>): Record<string, any> => {
  return Object.fromEntries(
    Object.entries(obj).filter(
      ([_, value]) =>
        value !== null && value !== undefined && value !== '' && !(Array.isArray(value) && value.length === 0)
    )
  );
};

// TODO: Some of this function seems hacky. See if you can improve it!
export const useCountSegmentRecipients = (campaignId: string, filters: FilterOptions) => {
  const cleanedFilters = removeEmptyValues(filters);
  const debouncedFilters = useDebouncedValue(cleanedFilters, 2000);
  const [recipientCount, setRecipientCount] = useState<number | undefined>();

  useEffect(() => {
    let isMounted = true;
    setRecipientCount(undefined);
    if (!campaignId) return;

    const countRecipients = SchemaBulkMessagingService.CountSegmentRecipients;
    countRecipients({
      campaignId,
      segment: {
        segmentId: '',
        filterOptions: debouncedFilters,
      },
    }).then((response) => {
      if (isMounted) {
        setRecipientCount(response.recipientCount ?? 0);
      }
    });

    return () => {
      isMounted = false;
    };
  }, [campaignId, JSON.stringify(debouncedFilters)]);

  return recipientCount;
};
